import { z } from 'zod';
import { zfd } from 'zod-form-data';
import { getClaimReasons } from '~/utils/line-item-claim';
import { makeLineItemClaimActionWithReason, redirect } from '~/utils/routing';

export const INPUT_NAME = 'reasonDetailId';

const makeFormSchema = (reason: ReturnType<typeof getClaimReasons>[number]) => {
  const ids = reason.claimReasonDetails.map(({ id }) => id);

  return zfd.formData({
    [INPUT_NAME]: zfd.numeric(
      z
        .number({ message: 'Please choose a reason.' })
        .int({ message: 'Invalid reason ID.' })
        .positive({ message: 'Invalid reason ID.' })
        .refine((id) => ids.includes(id), { message: 'Invalid reason ID.' }),
    ),
  });
};

export const { action, useActionResult: useReasonDetailActionResult } =
  makeLineItemClaimActionWithReason(
    ({ context: { claim, claimType }, formData }, appState) => {
      const reason = getClaimReasons(claimType, claim).find(
        ({ id }) => id === claim.reasonId,
      );

      if (!reason) {
        return new Error('Invalid claim reason.');
      }

      const result = makeFormSchema(reason).safeParse(formData);

      if (!result.success) {
        return {
          ok: false,
          message: result.error.message,
        };
      }

      const { reasonDetailId } = result.data;

      appState.dispatch(
        appState.actions.lineItemClaim.setReasonDetail(reasonDetailId),
      );

      return redirect('../follow-up');
    },
  );
